"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayCallsWrapperTemplate = void 0;
function StringArrayCallsWrapperTemplate() {
    return `
        const {stringArrayCallsWrapperName} = function (index, key) {
            index = index - 0;
            
            let value = {stringArrayName}[index];
            
            {decodeCodeHelperTemplate}
        
            return value;
        };
    `;
}
exports.StringArrayCallsWrapperTemplate = StringArrayCallsWrapperTemplate;
